import { yupResolver } from "@hookform/resolvers/yup";
import { makeStyles } from "@mui/styles";
import _, { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DateFns from "src/utils/DateFns";
import * as yup from "yup";
import { QueryInquiryPolicy } from "../../../../api/queryInquiryPolicy";
import ButtonCommon from "../../../../commonStyles/button/button";
import { currentYear, date,ivalidDate } from "../../../../const/date";
import { messageQueryError, VALIDATE_MESSAGE } from '../../../../const/message';
import { IResponseInquiryPolicy } from "../../../../interface/inquiryPolicy/responseInquiryPolicy";
import { useCheckLoading } from "../../../../providers/checkLoadingProvider";
import ContractInsuranceDocumentPerson from "../../../contractInsurance/contractInsuranceDocumentPerson";
import DontHasResult from "../../../dontHasResult/dontHasResult";
import ControllerTextField from "../../../Form/ControllerTextField";
import DatePickerCustom from "../../../Form/datePickerCustom";
import FormLabel from "../../../Form/FormLabel";
import RecaptchaGoogle from "../recaptchaGoogle/recaptchapGoogle";
import { textButton } from '../../../../const/index';
import { fieldNameInput } from '../../../../const/fieldInput';
const useStyles = makeStyles((theme) => {
  return {
    containerInput: {
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      marginBottom: "16px",
      [theme.breakpoints.down("md")]: {
        display: "block",
      },
    },
    itemInput: {
      width: "49%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    containerBtn: {
      display: "flex",
      justifyContent: "center",
      paddingBottom: "16px",
    },
    containerRecaptcha: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "16px",
    },
    mb16: {
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
    },
  };
});
//! Validate
const validationSchema = yup.object().shape({
  documentPerson: yup
    .string()
    .default("")
    .nullable()
    .required(VALIDATE_MESSAGE.REQUIRED("")),
  bornPeopleBuyInsurance: yup
    .string()
    .default("")
    .nullable()
    .required(VALIDATE_MESSAGE.REQUIRED(""))
    //! Validate

     .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          return value !== ivalidDate.validdob;
        }
      )
      .test(fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,(value) => {
          const dateValue = new Date(value);
          return `${dateValue}` === ivalidDate.ivalidDate ? value?.length > 14 : true
        })
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.DAYSLESSTHAN31,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.MONTHSLESSTHAN12,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[1]);
            return day <= 12;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");            
            const day = Number(convertResult[2]); 
            return day !==0 ;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");            
            const month = Number(convertResult[1]); 
            return month !==0 ;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.YEAR,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const year = Number(convertResult[0]);
            return year <= 1899 || year > currentYear ? false : true;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 29 && day > 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.minDate) <= new Date(value);
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleBuyInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.maxDate) > new Date(value);
          } else {
            return true;
          }
        }
      )
      ,
  bornPeopleUseInsurance: yup
    .string()
    .default("")
    .nullable()
    .required(VALIDATE_MESSAGE.REQUIRED(""))
    //! Validate

   .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          return value !== ivalidDate.validdob;
        }
      )
      .test(fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,(value) => {
          const dateValue = new Date(value);
          return `${dateValue}` === ivalidDate.ivalidDate ? value?.length > 14 : true
        })

      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.DAYSLESSTHAN31,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.MONTHSLESSTHAN12,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[1]);
            return day <= 12;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");            
            const day = Number(convertResult[2]); 
            return day !==0 ;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");            
            const month = Number(convertResult[1]); 
            return month !==0 ;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.YEAR,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const year = Number(convertResult[0]);
            return year <= 1899 || year > currentYear ? false : true;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.SPECIALDATE,
        (value) => {
          const dateValue = new Date(value);
          if (`${dateValue}` === ivalidDate.ivalidDate && value.length > 13) {
            const convertResult = value.replaceAll("/", ",").split(",");
            const day = Number(convertResult[2]);
            return day < 29 && day > 32;
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.minDate) <= new Date(value);
          } else {
            return true;
          }
        }
      )
      .test(
        fieldNameInput.bornPeopleUseInsurance,
        VALIDATE_MESSAGE.INVALIDDOB,
        (value) => {
          const convertDate = new Date(value);
          if (`${convertDate}` !== ivalidDate.ivalidDate) {
            const valueDate = DateFns?.formatDateTime(new Date(value));
            const convertResult = valueDate.replaceAll("/", ",").split(",");
            return `${convertResult[2]}`.startsWith("0")
              ? true
              : new Date(date.maxDate) > new Date(value);
          } else {
            return true;
          }
        }
      )
      ,
});
interface IProps {
}

interface IParams {
  frSystm?: string
}

const QueryDocumentNumber = (props: IProps) => {
  //! State
  const params: IParams = Object.fromEntries(
    new URLSearchParams(location.search.split("?")[1])
  );
  const [dataContract, setDataContract] =
    React.useState<IResponseInquiryPolicy>();
  const [valueRecaptcha, setValueRecaptcha] = React.useState<string>("");
  const [firtsView, setFirtsView] = React.useState<boolean>(false);
  const [isShowContract, setIsShowContract] = React.useState(false);
  const [heightBtnDate, setHeightBtnDate] = React.useState<number>();
  const [dataBody, setDataBody] = React.useState<boolean>();
  const { setIsLoading } = useCheckLoading();
  const [hideCaptcha, setHideCaptcha] = React.useState<boolean>();
  const [messageQueryText, setMessageQueryText] = React.useState<string>("");
  const [firstQuery, setFirstQuery] = React.useState(false);
  const refRecaptcha = React.useRef<any>();  
  const classes = useStyles();
  const { t } = useTranslation();
  const { control, handleSubmit, reset, formState, setValue, register,watch } =
    useForm<any>({
      mode: "all",
      resolver: yupResolver(validationSchema),
      defaultValues: validationSchema.getDefault(),
    });
  const allValueForm = (data: any) => {
    callQueryInquiryPolicy(data);
    setDataBody(data);
  };
  const clickQuery = () => {
    valueRecaptcha ? setFirtsView(false) : setFirtsView(true);

  };
  const checkValueRecapcha = (token: string) => {
    setValueRecaptcha(token);
  };
  const callFalse = (res) => {
    setDataContract(null);
    if (res.data.msgSts.code === "400") {
      refRecaptcha.current?.reset();
      setMessageQueryText("")
    } else {
      setMessageQueryText(messageQueryError[`msg${res.data.msgSts.code}`]);
    }
  };
  useEffect(() => {
    const elementInput = document.getElementById(fieldNameInput.bornPeopleBuyInsurance);
    const heightInput = elementInput?.clientHeight;
    setHeightBtnDate(heightInput + 1);
  }, []);

  const callQueryInquiryPolicy = async (body) => {
    setIsLoading(true);
    try {
      const res = await QueryInquiryPolicy(body,valueRecaptcha, params?.frSystm);
      res.data.msgSts.code === "000" ? setDataContract(res.data) : callFalse(res);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      const codeNumber = "007";
      setMessageQueryText(messageQueryError[`msg${codeNumber}`]);
    } finally {
      setIsLoading(false);
      setIsShowContract(true);
      setFirstQuery(true);
    }
  };
  useEffect(() => {
    resetCaptcha();
    setDataContract(null);
    setMessageQueryText("")
  }, [
    watch("bornPeopleBuyInsurance"),
    watch("bornPeopleUseInsurance"),
    watch("documentPerson"),
  ]);
  const resetCaptcha = () => {
    if (firstQuery) {
      refRecaptcha.current?.reset();
      setFirstQuery(false);
    }
  };
  //! Render
  return (
    <div style={{ marginBottom: "16px" }}>
      <div className={classes.containerInput}>
        <div
          className={`${classes.itemInput}`}
          style={{ width: "100%", marginBottom: "16px" }}
        >
          <ControllerTextField
            control={control}
            name={fieldNameInput.documentPerson}
            placeholder={t("placeholderDocumentPerson")}
            title={t(fieldNameInput.documentPerson)}
            required
            error={!_.isEmpty(formState.errors.documentPerson)}
            onChange={(e) => {
              const convertValue =
                e.target.value.length > 20
                  ? e.target.value.trim().slice(0, 20)
                  : e.target.value.trim();
              setValue(fieldNameInput.documentPerson, convertValue);
            }}
          />
        </div>
        <div className={`${classes.itemInput} ${classes.mb16}`}>
          <FormLabel
            title={t(fieldNameInput.bornPeopleBuyInsurance)}
            name={fieldNameInput.bornPeopleBuyInsurance}
            required
          />
          <DatePickerCustom
            control={control}
            name={fieldNameInput.bornPeopleBuyInsurance}
            error={!_.isEmpty(formState.errors.bornPeopleBuyInsurance)}
            heightInput={heightBtnDate}
            maxDate={new Date()}
          />
        </div>
        <div className={classes.itemInput}>
          <FormLabel
            title={t(fieldNameInput.bornPeopleUseInsurance)}
            name={fieldNameInput.bornPeopleUseInsurance}
            required
          />
          <DatePickerCustom
            control={control}
            name={fieldNameInput.bornPeopleUseInsurance}
            error={!_.isEmpty(formState.errors.bornPeopleUseInsurance)}
            heightInput={heightBtnDate}
            maxDate={new Date()}
          />
        </div>
      </div>
      {hideCaptcha === false ? (
        <></>
      ) : (
        <div className={classes.containerRecaptcha}>
          <RecaptchaGoogle
            checkValueRecapcha={checkValueRecapcha}
            isValueCaptcha={valueRecaptcha ? false : true}
            firtsView={firtsView}
            ref={refRecaptcha}
          />
        </div>
      )}
      <div className={classes.containerBtn} onClick={clickQuery}>
        <ButtonCommon onEvent={handleSubmit((data) => allValueForm(data))}>
          {textButton.query}
        </ButtonCommon>
      </div>
      {isShowContract && valueRecaptcha ? (
        !isEmpty(dataContract) ? (
          <ContractInsuranceDocumentPerson
            data={dataContract}
            dataBody={dataBody}
            valueRecaptcha={valueRecaptcha}
          />
        ) : (
          <>
            {messageQueryText && (
              <DontHasResult textMessage={messageQueryText} />
            )}
          </>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default QueryDocumentNumber;
